export default __webpack_public_path__ + "static/media/protectHER_logo.6c6ede4f.png";